module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_500_1000.a6c465d8.png";